<section class="centered">
  <img class="img-logo" src="../../../../assets/images/logo_login.png" />
  <h1>Ups!! Server Error (500)</h1>
  <h3>Ha ocurrido un error provocado por la petición al servicio. Lo sentimos!</h3>
</section>
